import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function AboutPage() {
  const {
    t,
    language
  } = useLanguage();
  const isHebrew = language === 'he';
  return <div className="max-w-4xl mx-auto px-4 md:px-6 py-8 md:py-12" data-id="element-72">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="bg-white rounded-lg shadow-md p-6 md:p-12" data-id="element-73">
        <h1 className="text-3xl md:text-5xl font-bold mb-6 md:mb-8 text-[#2A4B7C]" data-id="element-74">
          {t.about.title}
        </h1>
        <div className="prose prose-lg max-w-none" data-id="element-75">
          <p className="text-lg text-[#334E68]" data-id="element-76">{t.about.content}</p>
        </div>

        <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-gray-200" data-id="element-77">
          <div className="grid md:grid-cols-3 gap-8 text-center" data-id="element-78">
            <div data-id="element-79">
              <h3 className="text-3xl font-bold mb-2 text-[#2A4B7C]" data-id="element-80">1</h3>
              <p className="font-[700] text-[#2A4B7C]" data-id="element-81">
                {isHebrew ? 'הוצאות' : 'Issues Published'}
              </p>
            </div>
            <div data-id="element-82">
              <h3 className="text-3xl font-bold mb-2 text-[#2A4B7C]" data-id="element-83">10+</h3>
              <p className="font-[700] text-[#2A4B7C]" data-id="element-84">
                {isHebrew ? 'אנשים בצוות' : 'Team Members'}
              </p>
            </div>
            <div data-id="element-85">
              <h3 className="text-3xl font-bold mb-2 text-[#2A4B7C]" data-id="element-86">2026</h3>
              <p className="font-[700] text-[#2A4B7C]" data-id="element-87">
                {isHebrew ? 'נוסד ב' : 'Founded'}
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}